import type { FormStep } from "./StepTabs";

/** The next open step in a direction, or null when there is none: Continue and
 * Back skip the steps a switch has closed. */
export function nextOpenStep<K extends string>(
  steps: FormStep<K>[],
  current: K,
  direction: 1 | -1,
): K | null {
  const index = steps.findIndex((step) => step.key === current);
  for (let i = index + direction; i >= 0 && i < steps.length; i += direction) {
    if (!steps[i].disabled) return steps[i].key;
  }
  return null;
}

export type ClientUserStep =
  | "profile"
  | "access"
  | "folders"
  | "integrations"
  | "chatbot";

/** The steps of the client user form. Folders and Integrations show only to an
 * editor whose group gives that page to client users - anyone else would find a
 * list they may not change - and open once the page's switch is on. */
export function clientUserSteps({
  dataStorage,
  integrations,
  aiAgent,
  opensDataStorage,
  opensIntegrations,
}: {
  dataStorage: boolean;
  integrations: boolean;
  aiAgent: boolean;
  opensDataStorage: boolean;
  opensIntegrations: boolean;
}): FormStep<ClientUserStep>[] {
  const steps: FormStep<ClientUserStep>[] = [
    { key: "profile", label: "Profile" },
    { key: "access", label: "Access" },
  ];
  if (opensDataStorage) {
    steps.push({ key: "folders", label: "Folders", disabled: !dataStorage });
  }
  if (opensIntegrations) {
    steps.push({
      key: "integrations",
      label: "Integrations",
      disabled: !integrations,
    });
  }
  steps.push({ key: "chatbot", label: "Agent Set-Up", disabled: !aiAgent });
  return steps;
}
